import { ApiServiceV1 } from '@services/api.service';

export default {
  async getStats({ suffix, start, end }) {
    const { data } = await ApiServiceV1.get(`${suffix}/stats`, {
      params: { start, end },
    });
    return data || {};
  },
};
